import { defineMessages } from 'react-intl';

export const messages = defineMessages({
  title: {
    id: 'studio.Kv7C79',
    defaultMessage: 'OAuth2 client credentials',
  },
  explanation: {
    id: 'studio.vSv0O7',
    defaultMessage:
      'OAuth2 client credentials allow applications to perform actions on your behalf.',
  },
  loadError: {
    id: 'studio.wshv5u',
    defaultMessage: 'There was a problem loading your client credentials.',
  },
  retry: {
    id: 'studio.62nsdy',
    defaultMessage: 'Retry',
  },
  empty: {
    id: 'studio.C8qIYS',
    defaultMessage:
      'You currently haven’t registered any OAuth2 clients. If you don’t know what this is, you should probably leave this empty.',
  },
  register: {
    id: 'studio.deEeEI',
    defaultMessage: 'Register',
  },
  created: {
    id: 'studio.ORGv1Q',
    defaultMessage: 'Created',
  },
  deleteTitle: {
    id: 'studio.aHd3bT',
    defaultMessage: 'Delete client credentials',
  },
  deleteBody: {
    id: 'studio.+fuzcC',
    defaultMessage: 'Are you sure you want to delete these client credentials?',
  },
  deleteCancel: {
    id: 'studio.47FYwb',
    defaultMessage: 'Cancel',
  },
  deleteConfirm: {
    id: 'studio.K3r6DQ',
    defaultMessage: 'Delete',
  },
  description: {
    id: 'studio.Q8Qw5B',
    defaultMessage: 'Description',
  },
  descriptionHelp: {
    id: 'studio.r0mqR5',
    defaultMessage: 'A short description to render in the overview',
  },
  expires: {
    id: 'studio.xhQMeQ',
    defaultMessage: 'Expires',
  },
  never: {
    id: 'studio.du1laW',
    defaultMessage: 'Never',
  },
  expiresHelp: {
    id: 'studio.oxZwJN',
    defaultMessage: 'The date on which the client credentials expire',
  },
  credentials: {
    id: 'studio.pysIuq',
    defaultMessage: 'Client credentials',
  },
  credentialsHelp: {
    id: 'studio.4/VzZl',
    defaultMessage: 'Never share these client credentials with anyone.',
  },
  copiedSuccess: {
    id: 'studio.Wg9eSl',
    defaultMessage: 'Copied client credentials to clipboard',
  },
  copiedError: {
    id: 'studio.dklF9S',
    defaultMessage: 'Failed to copy client credentials to clipboard',
  },
  close: {
    id: 'studio.rbrahO',
    defaultMessage: 'Close',
  },
  cancel: {
    id: 'studio.47FYwb',
    defaultMessage: 'Cancel',
  },
  submit: {
    id: 'studio.VzzYJk',
    defaultMessage: 'Create',
  },
  scope: {
    id: 'studio.nso3Mj',
    defaultMessage: 'Scope',
  },
  revoke: {
    id: 'studio.tnRDuU',
    defaultMessage: 'Revoke',
  },
  unknownScope: {
    id: 'studio.K/9MYq',
    defaultMessage: 'This scope is not currently known. You may want to revoke this client.',
  },
  'apps:export': {
    id: 'studio.0/cdhu',
    defaultMessage: 'Export apps as zip files.',
  },
  'blocks:write': {
    id: 'studio.BWpepv',
    defaultMessage: 'Publish blocks and block versions',
  },
  'blocks:delete': {
    id: 'studio.F9iKim',
    defaultMessage: 'Delete block versions',
  },
  'organizations:write': {
    id: 'studio.03J9iZ',
    defaultMessage: 'Create and manage organizations',
  },
  'apps:write': {
    id: 'studio.NSOI8P',
    defaultMessage: 'Create and modify apps',
  },
  'apps:delete': {
    id: 'studio.9VC1l4',
    defaultMessage: 'Delete apps.',
  },
  'organizations:delete': {
    id: 'studio.kdMZ78',
    defaultMessage: 'Delete organizations.',
  },
  'resources:read': {
    id: 'studio.snEcFS',
    defaultMessage: 'Read app resources',
  },
  'resources:write': {
    id: 'studio.kukswA',
    defaultMessage: 'Create, update, and delete app resources',
  },
  'groups:read': {
    id: 'studio.V6/PgG',
    defaultMessage: 'Read app groups',
  },
  'groups:write': {
    id: 'studio.JV/lzM',
    defaultMessage: 'Create and manage app groups',
  },
  'assets:write': {
    id: 'studio.2lwxpZ',
    defaultMessage: 'Create app assets',
  },
});
